import { getRequest } from "../../../services/RestServices";
import * as urls from "../../api/scheduler/url";

export const getReasonsData = async () => {
  try {
    return await getRequest(urls.REASONS_DATA);
  } catch (err) {
    return err;
  }
};
